import React                 from "react"
import {Redirect, Route}     from "react-router-dom"
import {RouteComponentProps} from "react-router"

import {IonPage, IonRouterOutlet} from "@ionic/react"

import PageBlocklistKeyItem  from "../pages/BlocklistKeys/Item"
import PageBlocklistKeysList from "../pages/BlocklistKeys/List"

const BlocklistKeys: React.FC<RouteComponentProps> = ({ match }) => {
    return (
        <IonPage>
            <IonRouterOutlet animated={false}>
                <Route exact path={match.url}                   component={PageBlocklistKeysList} />
                <Route       path={`${match.url}/:id/:segment`} component={PageBlocklistKeyItem} />

                <Redirect exact from={`${match.url}/:id`} to={`${match.url}/:id/view`} />
            </IonRouterOutlet>
        </IonPage>
    )
}

export default BlocklistKeys